import { AumDTO } from '@types';
import { Mapper, MapperParams } from './type.mapper';
import { MapperFactory } from './mapper-factory';
import { Aum } from '@products/models/aum';

export class AumMapper extends Mapper<Aum> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(aumDTO: AumDTO): Aum {
    return {
      asOfDate: aumDTO.asofdate,
      totalNetAssetsStd: aumDTO.totnetassetsstd,
      totalNetAssets: aumDTO.totnetassets,
    };
  }
}
